module.exports = __webpack_public_path__ + "img/priceScheduleGuide.b2bcde62.jpg";